export enum LeadViewTabIndex {
    OVERVIEW,
    ACTIVITY,
    List,
    CONTACT,
    // TASK,
    DOCUMENTS,
};

 export enum LeadViewTabIndexWithContact {
     OVERVIEW,
     ACTIVITY,
     TASK,
     DOCUMENTS,
  };
